import { VStack, Stack, Icon, Text } from "@chakra-ui/react";

const ChoiceStep = ({ options, onSelect, selectedValue, isError }) => {
  const isTwoOptions = options.length <= 2;

  return (
      <Stack
          direction={{ base: "column", md: isTwoOptions ? "row" : "column" }}
          px={{ base: 2, md: 16 }}
          gap={{ base: 4, md: isTwoOptions ? 10 : 4 }}
          mb={{ base: isError ? 1 : 6, md: isError ? 3 : 14 }}
          justify={{ base: "flex-start", md: "center" }}
          align="center"
      >
        {options.map((option) => {
          const isSelected = selectedValue === option.value;
          return (
              <VStack
                  key={option.value}
                  as="button"
                  onClick={() => onSelect(option.value)}
                  spacing={3}
                  px={{ base: isTwoOptions ? 2 : 3, md: isTwoOptions ? 4 : 5 }}
                  py={{ base: isTwoOptions ? 7 : 3, md: isTwoOptions ? 14 : 5 }}
                  borderWidth={2}
                  borderColor={isError ? "red.500" : isSelected ? "green.500" : "gray.200"}
                  bg={isSelected ? "green.50" : "gray.50"}
                  rounded="lg"
                  _hover={{ borderColor: "green.300" }}
                  transition="all 0.2s"
                  align="center"
                  justify="center"
                  w="100%"
              >
                {option.icon && (
                    <Icon as={option.icon} w={{ base: 6, md: 12 }} h={{ base: 6, md: 12 }} />
                )}
                <Text fontSize={{ base: "md !important", md: "xl !important" }} color="black !important" fontWeight="semibold">
                  {option.label}
                </Text>
              </VStack>
          );
        })}
      </Stack>
  );
};

export default ChoiceStep;